import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { HttpApiService } from '../../../../../shared/services/base/http-api.service';
import { ValidationMessageService } from '../../../../../shared/services/base/validation-message-handle';
import { MessageService } from 'primeng/api';
import { finalize } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { TransportUnitDriverModel } from 'src/app/shared/entities/transport-unit-driver.model';
import { TransportUnitDriverService } from 'src/app/shared/services/app/transport-unit-driver.service';


@Component({
    selector: 'app-transport-unit-driver-add-edit',
    templateUrl: './transport-unit-driver-add-edit.component.html',
    styleUrls: ['./transport-unit-driver-add-edit.component.scss']
})
export class TransportUnitDriverAddEditComponent implements OnInit {

    public uid: string = null;
    public itemModel: TransportUnitDriverModel = new TransportUnitDriverModel();
    public loading = false;
    public form: UntypedFormGroup;

    constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private formBuilder: UntypedFormBuilder,
        private httpApiService: HttpApiService,
        private validationMessageService: ValidationMessageService,
        private itemService: TransportUnitDriverService,
        private messageService: MessageService
    ) {
    }

    ngOnInit(): void {
        this.uid = (this.config.data) ? this.config.data.uid : null;

        this.createForm();

        if (this.uid) {
            this.getItem();
        }

        return;
    }

    onCloseDialog(item: TransportUnitDriverModel) {
        this.ref.close(item);
    }


    createForm(): void {
        this.form = this.formBuilder.group({
            uid: [this.itemModel.firstName],
            firstName: [this.itemModel.firstName, [Validators.required, Validators.maxLength(200)]],
            lastName: [this.itemModel.lastName, [Validators.required, Validators.maxLength(200)]],
            phone: [this.itemModel.phone, [Validators.required, Validators.maxLength(200)]],
            email: [this.itemModel.email],
        });
    }

    getItem(): void {
        this.loading = true;
        this.itemService.get(this.uid)
            .pipe(finalize(() => this.loading = false))
            .subscribe((response: any) => {
                this.itemModel.map(response.payload);
                this.form.patchValue(this.itemModel);
            });
    }


    onCancel(): void {
        this.ref.close(null);
    }

    checkIfFormValid(): boolean {
        if (this.form.invalid) {
            this.messageService.add({
                severity: 'error',
                summary: 'Formularul nu este valid!',
                detail: 'Vericficati toate campurile si incercati din nou.'
            });
            this.form.markAllAsTouched();
            return false;
        }
        return true;
    }

    onSave(): void {
        if (!this.checkIfFormValid()) {
            return;
        }
        this.loading = true;
        const data = this.form.getRawValue();
        this.itemService.set(data)
            .pipe(finalize(() => this.loading = false))
            .subscribe((response: any) => {
                this.itemModel.map(response.payload);
                this.form.patchValue(this.itemModel);
                this.messageService.add({
                    severity: 'success',
                    summary: 'Soferul de unitate transport a fost salvat cu success!'
                });
                this.ref.close(this.itemModel);
            }, err => {
                if (err instanceof HttpErrorResponse) {
                    this.validationMessageService.serverSideValidation(err, this.form, '', true);
                }
            });
    }
}
